import * as Unicons from '@iconscout/react-unicons';
import { Button, Form, Input, Pagination, Select } from 'antd';
import { Link } from 'react-router-dom';
import { Sidebar } from '../../components/Sidebar';
import SidebarAndContainer from '../../components/sidebar-and-container/sidebar-and-container.component';

export const Favoritos = () => {
  const { Option } = Select;

  return (
    <>
      <SidebarAndContainer>
        <div className="dashboard">
          <div className="d-flex-row j-start-a-center mb-20">
            <Link to="meus-cursos">
              <Button className="button-blue">
                <Unicons.UilArrowLeft />
                Voltar
              </Button>
            </Link>
            <h1 className="fav-title">Favoritos (4)</h1>
          </div>
          <Form
            id="box-form"
            className="d-flex-row j-start-a-center w-100 mb-20"
          >
            <div className="d-flex-row j-start-a-center input-box w-100">
              <Unicons.UilSearch
                size="20"
                color="var(--dark-secondary)"
                className="iconForm"
              />
              <Form.Item name="search" noStyle={true}>
                <Input placeholder="Buscar trilha por curso ou status" />
              </Form.Item>
            </div>
            <div className="d-flex-row w-100 j-between-a-center select-box">
              Curso
              <Select
                defaultValue="Todos"
                style={{ width: 85 }}
                className="select-fav"
              >
                <Option value="jack">Jack</Option>
                <Option value="lucy">Lucy</Option>
              </Select>
            </div>
            <div className="d-flex-row w-100 j-between-a-center select-box">
              Curso
              <Select
                defaultValue="Status"
                style={{ width: 85 }}
                className="select-fav"
              >
                <Option value="jack">Jack</Option>
                <Option value="lucy">Lucy</Option>
              </Select>
            </div>
          </Form>
          <div className="d-flex-row j-start-a-start w-100 mb-20 flex-wrap">
            {/* <Curso header={true} name="digitais" curso="Como transformar minha disciplina em um e-book pt.1" />
            <Curso header={true} name="digitais" curso="Como transformar minha disciplina em um e-book pt.2" />
            <Curso header={true} name="speech" curso="e-book: Dicas e práticas de oratória" />
            <Curso header={true} name="code" curso="Como transformar minha disciplina em um e-book pt.2" /> */}
          </div>
          <div className="d-flex-row j-center-a-center w-100 pb-50">
            <Pagination defaultCurrent={1} total={50} />
          </div>
        </div>
      </SidebarAndContainer>
    </>
  );
};
